export const LayersTypes = {
  INTERACTIVE_KP_LAYER: 'interactive_kp_layer',
  ROUTE_DATA_LAYER: 'route_data_layer',
  INTERACTIVE_EVENT_TYPE_LAYER: 'interactive_event_type_layer',
  SURVEY_BATHY_DATA_LAYER: 'survey_bathy_data_layer',
  SURVEY_EVENT_DATA_LAYER: 'survey_event_data_layer',
  BATHY_MAP_LAYER: 'bathy_map_layer',
  ARCGIS_OCEAN_REFERENCE_LAYER: 'arcgis_ocean_reference_layer',
  WEATHER_MAP_LAYER: 'weather_map_layer',
  OPEN_SEA_MAP_LAYER: 'open_sea_map_layer',
  INTERACTIVE_MEASURE_LAYER: 'interactive_measure_layer'
};

export type LayerType = (typeof LayersTypes)[keyof typeof LayersTypes];
